import gql from 'graphql-tag';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import Loading from '../Loading';
import NoElements from '../states/NoElements';
import Activity from './Activity';

const ACTIVITY_CREATED_SUBSCRIPTION = gql`
  subscription activityCreated($id: String, $type: String, $projectId: String) {
    activityCreated(
      objectableId: $id
      objectableType: $type
      projectId: $projectId
    ) {
      id
      type
      subtype
      subaction
      objectable_id
      objectable_type
      created_at
      project_id
      data
      user {
        id
        username
        first_name
        last_name
        email
        avatar {
          id
          path
        }
      }
    }
  }
`;

const queryActivities = gql`
  query Activities($id: String!, $type: String, $cursor: ID) {
    activities(objectableId: $id, objectableType: $type, cursor: $cursor) {
      id
      type
      subtype
      subaction
      objectable_id
      objectable_type
      created_at
      project_id
      data
      user {
        id
        username
        first_name
        last_name
        email
        avatar {
          id
          path
        }
      }
    }
  }
`;

const queryDashboardActivities = gql`
  query Activities(
    $id: String
    $type: String
    $projectId: String
    $loadAll: Boolean
    $cursor: ID
  ) {
    activities(
      objectableId: $id
      objectableType: $type
      projectId: $projectId
      loadAll: $loadAll
      cursor: $cursor
    ) {
      id
      type
      subtype
      subaction
      objectable_id
      objectable_type
      created_at
      project_id
      data
      user {
        id
        username
        first_name
        last_name
        email
        avatar {
          id
          path
        }
      }
    }
  }
`;

const withAppropriateActivityFeedData = BaseComponent => props => {
  // eslint-disable-next-line
  const query = props.projectId ? queryDashboardActivities : queryActivities;
  const withActivityFeedData = graphql(query, {
    options: ({ id, type, projectId, loadAll }) => ({
      variables: {
        id,
        type,
        projectId,
        loadAll,
      },
      fetchPolicy: 'network-only',
    }),
    props: props => {
      return {
        subscribeToNewActivities: currentProps => {
          return props.data.subscribeToMore({
            document: ACTIVITY_CREATED_SUBSCRIPTION,
            variables: {
              objectableId: currentProps.id,
              objectableType: currentProps.type,
              projectId: currentProps.projectId,
            },
            updateQuery: (prev, { subscriptionData }) => {
              if (!subscriptionData.data) {
                return prev;
              }

              const newActivity = subscriptionData.data.activityCreated;

              const x = [...prev.activities];

              x.unshift(newActivity);

              return { ...prev, activities: x };
            },
          });
        },
        ...props,
      };
    },
  });

  withActivityFeedData.propTypes = {
    id: PropTypes.string,
    type: PropTypes.string,
  };

  const Wrapped = withActivityFeedData(BaseComponent);
  return <Wrapped {...props} />;
};

withAppropriateActivityFeedData.propTypes = {
  projectId: PropTypes.string,
};

@connect()
@withAppropriateActivityFeedData
class ActivityFeed extends PureComponent {
  static propTypes = {
    projectId: PropTypes.string,
    id: PropTypes.string,
    type: PropTypes.string,
    currentUser: PropTypes.instanceOf(Map),
    data: PropTypes.object,
  };

  componentWillMount() {
    const { subscribeToNewActivities } = this.props;
    this.subscription = subscribeToNewActivities(this.props);
  }

  componentWillUnmount() {
    this.subscription();
  }

  componentWillReceiveProps(nextProps) {
    const { subscribeToNewActivities } = nextProps;

    if (nextProps.id !== this.props.id) {
      // TODO: Need to kill the old subscription
      this.subscription();
      this.subscription = subscribeToNewActivities(nextProps);
    }
  }

  loadMore = () => {
    const {
      data: { fetchMore, activities },
    } = this.props;

    const cursor = activities[activities.length - 1].id;

    fetchMore({
      variables: {
        cursor,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        const previousEntry = previousResult.activities;
        const newActivities = fetchMoreResult.activities;

        return {
          activities: [...previousEntry, ...newActivities],
        };
      },
    });
  };

  render() {
    const {
      data: { activities, loading },
      dispatch,
      dashboard,
    } = this.props;

    if (!activities && loading) {
      return <Loading loadingMessage="Loading activities..." />;
    } else if (!activities.length) {
      if (dashboard)
        return (
          <NoElements
            missingEntity={'Activities'}
            missingType={'dashboardActivities'}
            dashboard
          />
        );

      return (
        <NoElements missingEntity={'activities'} missingType={'activities'} />
      );
    }

    return (
      <div style={{ ...this.props.style }}>
        {activities.map(activity => (
          <Activity
            key={activity.id}
            activity={activity}
            dispatch={dispatch}
            push={push}
          />
        ))}
        {activities &&
          activities.length && (
            <div
              className="btn btn-primary center-button"
              style={{ flex: 'none', margin: 0 }}
              onClick={this.loadMore}
            >
              Load More
            </div>
          )}
      </div>
    );
  }
}

export default ActivityFeed;



// WEBPACK FOOTER //
// ./src/components/ActivityFeed/index.js